import React from 'react';
import { takeEvery, call } from 'redux-saga/effects';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Map } from 'immutable';
import { KineticLib, clearToasts } from '@kineticdata/react';
import {
  CommonComponents,
  FormComponents,
  TableComponents,
} from '@kineticdata/ui';
import { regHandlers, regSaga } from './store';
import { router } from './root';
import './assets/styles/master.scss';
import { LoginScreen } from './components/authentication/LoginScreen';
import { LoginDialog } from './components/authentication/LoginDialog';

regHandlers({
  LOCATION_CHANGE: (state, { payload }) =>
    state.setIn(
      ['page'],
      Map({ names: payload, state: state.getIn(['page', 'state']) || Map() }),
    ),
});

regSaga(
  takeEvery('LOCATION_CHANGE', function* () {
    yield call(clearToasts);
  }),
);

export const App = props => (
  <>
    <Helmet>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      />
    </Helmet>

    <Provider store={props.store}>
      <KineticLib
        components={{
          ...CommonComponents,
          fields: { ...FormComponents },
          ...TableComponents,
        }}
        locale="en"
        system
      >
        {({ initialized, loggedIn, loginProps, timedOut }) =>
          !initialized ? null : !loggedIn ? (
            <LoginScreen {...loginProps} />
          ) : (
            <>
              <RouterProvider router={router} />
              <LoginDialog isOpen={timedOut} {...loginProps} />
            </>
          )
        }
      </KineticLib>
    </Provider>
  </>
);
